import { computed } from 'vue'
import setWindowSettings from '@/assets/ts/setting'

setWindowSettings()

function getLocalExperimentValue() {
	const localRandomNumber = localStorage.getItem('local_rand_0to9')
	const randomNumber =
		localRandomNumber !== null
			? Number(localRandomNumber)
			: window.BUYANDSHIP.settings?.rand_0to9 || 0
	if (localRandomNumber === null) {
		localStorage.setItem('local_rand_0to9', randomNumber.toString())
	}
	return randomNumber
}

export function isExpressCheckoutEnabled() {
	const host = window.BUYANDSHIP.settings.productsharing_express_checkout_host
	return !!(host && host !== '')
}

export function checkIsPhActivation() {
	return window.BUYANDSHIP.settings?.experiments?.ph_activation_2024 === 'yes'
}

export function getPhLayoutType() {
	return 'A'
}

export function checkIsNewReferralFlow() {
	return (
		window.BUYANDSHIP.settings?.experiments?.member_new_referral_flow === 'yes'
	)
}

export function checkIsHomeRevamp2025() {
	const isExperimentEnabled =
		window.BUYANDSHIP.settings?.experiments?.mcr_home_revamp_2025 === 'yes'
	if (!isExperimentEnabled) {
		return false
	}

	const randomNumber = getLocalExperimentValue()

	// Control (A): 0,1,2,3,4 → return false
	// Variant B: 5,6,7,8,9 → return true
	return randomNumber >= 5
}

export const isRegionSupportBuyforyou = computed(() => {
	const buyForYouApiHost = window.BUYANDSHIP.settings.buyforyou_api_host
	return !!buyForYouApiHost && buyForYouApiHost !== ''
})

export function isStagingEnvironment() {
	return window.location.href.includes('https://test-')
}

export function checkIsSeoEnhancement() {
	return window.BUYANDSHIP.settings.experiments?.seo_202508 === 'yes'
}

export function checkShouldRedirectLinkForSeo() {
	return import.meta.env.PUBLIC_MODE === 'production' && checkIsSeoEnhancement()
	// Amazon
	// return (
	// 	import.meta.env.PUBLIC_MODE === 'development' &&
	// 	import.meta.env.PROD &&
	// 	checkIsSeoEnhancement()
	// )
}

export function isGlobalSite() {
	return window.BUYANDSHIP.settings?.current_country === 'global'
}

export function checkIsNewCommunityPost() {
	const isExperimentEnabled =
		window.BUYANDSHIP.settings?.experiments?.community_post_202509 === 'yes'
	if (!isExperimentEnabled) {
		return false
	}

	const randomNumber = getLocalExperimentValue()

	return randomNumber >= 5
}

export function checkIsShowMercariBrandPhase2() {
	const randomNumber = getLocalExperimentValue()

	return randomNumber >= 5
}
